<template>
  <section class="product-food">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field>
          <p class="control">
            <a
              :href="helpImageUrl('餐食住宿.png')"
              @click.prevent="onClickImage(helpImageUrl('餐食住宿.png'))"
              style="margin-left: 1rem;"
            >
              <img
                :src="helpImageUrl('餐食住宿.png')"
                alt="餐食住宿"
                width="56"
              />
            </a>
          </p>

          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 240px; position: absolute; top: 10px; right: 10px;"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>

        <editor
          ref="remark1_editor"
          v-model="form.remark1"
          :area="product.image_path"
          :height="editorHeight"
        ></editor>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'FoodForm',
  components: { Editor },

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      product_code: this.product.code,
      form: this.extractFormValues(this.product),

      isImageModalActive: false,
      selectedImageUrl: null,

      windowHeight: window.innerHeight
    }
  },
  computed: {
    editorHeight() {
      return this.windowHeight - 350
    }
  },
  validations: {
    form: {
      remark1: {}
    }
  },
  watch: {
    product(newProduct) {
      this.product_code = newProduct.code
      this.form = this.extractFormValues(newProduct)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    extractFormValues(data) {
      return {
        remark1: data.remark1 || ''
      }
    },
    async onSend() {
      this.form.remark1 = this.$refs.remark1_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${PRODUCTS_API}/${this.product_code}/food`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>
